export interface ImageItem {
  id: string;
  src: string;
  description: string;
  isIntruder: boolean;
}

export interface GamePage {
  id: string;
  title: string;
  description: string;
  images: ImageItem[];
  intruderSequence: string[];
  revealedLetters: string;
}

export const gamePages: GamePage[] = [
  {
    id: 'tour-concerti',
    title: 'Il Tour dei concerti',
    description: 'Quali artisti non c\'entrano?',
    images: [
      { id: 'arkey', src: '/images/tour-concerti/Arkey.jpg', description: 'Arkey', isIntruder: false },
      { id: 'badbunny', src: '/images/tour-concerti/Bad Bunny.jpg', description: 'Bad Bunny', isIntruder: false },
      { id: 'blackeyedpeas', src: '/images/tour-concerti/Black Eyed Peas.jpg', description: 'Black Eyed Peas', isIntruder: false },
      { id: 'calcutta', src: '/images/tour-concerti/Calcutta.jpg', description: 'Calcutta', isIntruder: false },
      { id: 'caparezza', src: '/images/tour-concerti/Caparezza.jpg', description: 'Caparezza', isIntruder: false },
      { id: 'clubdogo', src: '/images/tour-concerti/Club Dogo.jpg', description: 'Club Dogo', isIntruder: false },
      { id: 'coez', src: '/images/tour-concerti/Coez.jpg', description: 'Coez', isIntruder: false },
      { id: 'fabrifibra', src: '/images/tour-concerti/Fabri Fibra.jpg', description: 'Fabri Fibra', isIntruder: false },
      { id: 'gue', src: '/images/tour-concerti/Guè.jpg', description: 'Guè', isIntruder: false },
      { id: 'hermanmedrano', src: '/images/tour-concerti/Herman Medrano.jpg', description: 'Herman Medrano', isIntruder: false },
      { id: 'jovanotti', src: '/images/tour-concerti/Jovanotti.jpg', description: 'Jovanotti', isIntruder: false },
      { id: 'lazza', src: '/images/tour-concerti/Lazza.jpg', description: 'Lazza', isIntruder: false },
      { id: 'marracash', src: '/images/tour-concerti/Marracash.jpg', description: 'Marracash', isIntruder: false },
      { id: 'paolaechiara', src: '/images/tour-concerti/Paola e Chiara.jpg', description: 'Paola e Chiara', isIntruder: false },
      { id: 'prodigy', src: '/images/tour-concerti/Prodigy.jpg', description: 'Prodigy', isIntruder: false },
      { id: 'bigmama', src: '/images/tour-concerti/Intruso Big Mama.jpg', description: 'Big Mama', isIntruder: true },
      { id: 'kidyugi', src: '/images/tour-concerti/Intruso Kid Yugi.jpg', description: 'Kid Yugi', isIntruder: true },
      { id: 'radiohead', src: '/images/tour-concerti/Intruso Radiohead.jpg', description: 'Radiohead', isIntruder: true }
    ],
    intruderSequence: ['bigmama', 'kidyugi', 'radiohead'],
    revealedLetters: 'SO'
  },
  {
    id: 'paese-origine',
    title: 'Il Paese d\'origine',
    description: 'Trova i luoghi intrusi',
    images: [
      { id: 'bottega', src: '/images/paese-origine/Bottega di Ester.jpg', description: 'Bottega di Ester', isIntruder: false },
      { id: 'colmolin', src: '/images/paese-origine/Col Molin.jpg', description: 'Col Molin', isIntruder: false },
      { id: 'colroigo', src: '/images/paese-origine/Col Roigo.jpg', description: 'Col Roigo', isIntruder: false },
      { id: 'colledante', src: '/images/paese-origine/Colle di Dante.jpg', description: 'Colle di Dante', isIntruder: false },
      { id: 'cremasco', src: '/images/paese-origine/Cremasco.jpg', description: 'Cremasco', isIntruder: false },
      { id: 'cubamia', src: '/images/paese-origine/CubaMia.jpg', description: 'CubaMia', isIntruder: false },
      { id: 'fornace', src: '/images/paese-origine/Fornace Panizzon.jpg', description: 'Fornace Panizzon', isIntruder: false },
      { id: 'gelateria', src: '/images/paese-origine/Gelateria Arcobaleno.jpg', description: 'Gelateria Arcobaleno', isIntruder: false },
      { id: 'iber', src: '/images/paese-origine/Iber Battocchio.jpg', description: 'Iber Battocchio', isIntruder: false },
      { id: 'norgetti', src: '/images/paese-origine/Norgetti.jpg', description: 'Norgetti', isIntruder: false },
      { id: 'parrocchia', src: '/images/paese-origine/Parrocchia.jpg', description: 'Parrocchia', isIntruder: false },
      { id: 'pizzeria', src: '/images/paese-origine/Pizzeria Il Pomodoro.jpg', description: 'Pizzeria Il Pomodoro', isIntruder: false },
      { id: 'vallesanta', src: '/images/paese-origine/Valle Santa Felicita.jpg', description: 'Valle Santa Felicita', isIntruder: false },
      { id: 'albarella', src: '/images/paese-origine/Intruso Albarella.jpg', description: 'Albarella', isIntruder: true },
      { id: 'pontevecchio', src: '/images/paese-origine/Intruso Ponte Vecchio.jpg', description: 'Ponte Vecchio', isIntruder: true },
      { id: 'vallastaro', src: '/images/paese-origine/Intruso Val Lastaro.jpg', description: 'Val Lastaro', isIntruder: true }
    ],
    intruderSequence: ['albarella', 'pontevecchio', 'vallastaro'],
    revealedLetters: 'TT'
  },
  {
    id: 'compagni-viaggio',
    title: 'I compagni di Viaggio',
    description: 'Chi sono gli intrusi?',
    images: [
      { id: 'arturo', src: '/images/compagni-viaggio/Arturo_.jpg', description: 'Arturo', isIntruder: false },
      { id: 'lola', src: '/images/compagni-viaggio/Lola.jpg', description: 'Lola', isIntruder: false },
      { id: 'merlino', src: '/images/compagni-viaggio/Merlino.jpg', description: 'Merlino', isIntruder: false },
      { id: 'mia', src: '/images/compagni-viaggio/Mia.jpg', description: 'Mia', isIntruder: false },
      { id: 'milla', src: '/images/compagni-viaggio/Milla.jpg', description: 'Milla', isIntruder: false },
      { id: 'minnie', src: '/images/compagni-viaggio/Minnie.jpg', description: 'Minnie', isIntruder: false },
      { id: 'pippa', src: '/images/compagni-viaggio/Pippa.jpg', description: 'Pippa', isIntruder: false },
      { id: 'ragu', src: '/images/compagni-viaggio/Ragù_.jpg', description: 'Ragù', isIntruder: false },
      { id: 'scossy', src: '/images/compagni-viaggio/Scossy.jpg', description: 'Scossy', isIntruder: false },
      { id: 'ugo', src: '/images/compagni-viaggio/Ugo.jpg', description: 'Ugo', isIntruder: false },
      { id: 'wendyepiciulo', src: '/images/compagni-viaggio/Wendy e Piciulo.jpg', description: 'Wendy e Piciulo', isIntruder: false },
      { id: 'marley', src: '/images/compagni-viaggio/Intruso Marley.jpg', description: 'Marley', isIntruder: true },
      { id: 'matilda', src: '/images/compagni-viaggio/Intruso Matilda.jpg', description: 'Matilda', isIntruder: true },
      { id: 'salem', src: '/images/compagni-viaggio/Intruso Salem.jpg', description: 'Salem', isIntruder: true }
    ],
    intruderSequence: ['marley', 'matilda', 'salem'],
    revealedLetters: 'OL'
  },
  {
    id: 'mete',
    title: 'Le Mete',
    description: 'Quali mete non c\'entrano?',
    images: [
      { id: 'amsterdam', src: '/images/mete/Amsterdam.jpg', description: 'Amsterdam', isIntruder: false },
      { id: 'budapest', src: '/images/mete/Budapest.jpg', description: 'Budapest', isIntruder: false },
      { id: 'cammino', src: '/images/mete/Cammino di Santiago.jpg', description: 'Cammino di Santiago', isIntruder: false },
      { id: 'copenaghen', src: '/images/mete/Copenaghen.jpg', description: 'Copenaghen', isIntruder: false },
      { id: 'costiera', src: '/images/mete/Costiera Amalfitana.jpg', description: 'Costiera Amalfitana', isIntruder: false },
      { id: 'croazia', src: '/images/mete/Croazia.jpg', description: 'Croazia', isIntruder: false },
      { id: 'cuba', src: '/images/mete/Cuba.jpg', description: 'Cuba', isIntruder: false },
      { id: 'edimburgo', src: '/images/mete/Edimburgo.jpg', description: 'Edimburgo', isIntruder: false },
      { id: 'francia', src: '/images/mete/Francia.jpg', description: 'Francia', isIntruder: false },
      { id: 'lanzarote', src: '/images/mete/Lanzarote.jpg', description: 'Lanzarote', isIntruder: false },
      { id: 'portogallo', src: '/images/mete/Portogallo.jpg', description: 'Portogallo', isIntruder: false },
      { id: 'sardegna', src: '/images/mete/Sardegna.jpg', description: 'Sardegna', isIntruder: false },
      { id: 'srilanka', src: '/images/mete/Sri Lanka.jpg', description: 'Sri Lanka', isIntruder: false },
      { id: 'antartide', src: '/images/mete/Intruso Antartide.jpg', description: 'Antartide', isIntruder: true },
      { id: 'maldive', src: '/images/mete/Intruso Maldive.jpg', description: 'Maldive', isIntruder: true },
      { id: 'marocco', src: '/images/mete/Intruso Marocco.jpg', description: 'Marocco', isIntruder: true }
    ],
    intruderSequence: ['antartide', 'maldive', 'marocco'],
    revealedLetters: 'AS'
  },
  {
    id: 'chi-sono',
    title: 'Ma questi chi sono',
    description: 'Trova gli intrusi tra le persone',
    images: [
      { id: 'a', src: '/images/chi-sono/A.jpg', description: 'A', isIntruder: false },
      { id: 'd', src: '/images/chi-sono/D.jpg', description: 'D', isIntruder: false },
      { id: 'e', src: '/images/chi-sono/E.jpg', description: 'E', isIntruder: false },
      { id: 'f', src: '/images/chi-sono/F.jpg', description: 'F', isIntruder: false },
      { id: 'f1', src: '/images/chi-sono/F(1).jpg', description: 'F', isIntruder: false },
      { id: 'g', src: '/images/chi-sono/G.jpg', description: 'G', isIntruder: false },
      { id: 'j', src: '/images/chi-sono/J.jpg', description: 'J', isIntruder: false },
      { id: 'l', src: '/images/chi-sono/L.jpg', description: 'L', isIntruder: false },
      { id: 'l1', src: '/images/chi-sono/L(1).jpg', description: 'L', isIntruder: false },
      { id: 'l2', src: '/images/chi-sono/L(2).jpg', description: 'L', isIntruder: false },
      { id: 'm', src: '/images/chi-sono/M.jpg', description: 'M', isIntruder: false },
      { id: 'm1', src: '/images/chi-sono/M(1).jpg', description: 'M', isIntruder: false },
      { id: 'p', src: '/images/chi-sono/P.jpg', description: 'P', isIntruder: false },
      { id: 'p1', src: '/images/chi-sono/P(1).jpg', description: 'P', isIntruder: false },
      { id: 'r', src: '/images/chi-sono/R.jpg', description: 'R', isIntruder: false },
      { id: 't', src: '/images/chi-sono/T.jpg', description: 'T', isIntruder: false },
      { id: 'intruso_j', src: '/images/chi-sono/Intruso J.jpg', description: 'J', isIntruder: true },
      { id: 'intruso_k', src: '/images/chi-sono/Intruso K.png', description: 'K', isIntruder: true },
      { id: 'intruso_s', src: '/images/chi-sono/Intruso S.png', description: 'S', isIntruder: true }
    ],
    intruderSequence: ['intruso_j', 'intruso_k', 'intruso_s'],
    revealedLetters: 'PO'
  },
  {
    id: 'e-queste',
    title: 'E queste',
    description: 'Chi sono gli intrusi?',
    images: [
      { id: 'a', src: '/images/e-queste/A.jpg', description: 'A', isIntruder: false },
      { id: 'a1', src: '/images/e-queste/A(1).jpg', description: 'A', isIntruder: false },
      { id: 'b', src: '/images/e-queste/B.jpg', description: 'B', isIntruder: false },
      { id: 'c', src: '/images/e-queste/C.jpg', description: 'C', isIntruder: false },
      { id: 'd', src: '/images/e-queste/D.jpg', description: 'D', isIntruder: false },
      { id: 'e', src: '/images/e-queste/E.jpg', description: 'E', isIntruder: false },
      { id: 'e1', src: '/images/e-queste/E(1).jpg', description: 'E', isIntruder: false },
      { id: 'f', src: '/images/e-queste/F.jpg', description: 'F', isIntruder: false },
      { id: 'f1', src: '/images/e-queste/F(1).jpg', description: 'F', isIntruder: false },
      { id: 'g', src: '/images/e-queste/G.jpg', description: 'G', isIntruder: false },
      { id: 'l', src: '/images/e-queste/L.jpg', description: 'L', isIntruder: false },
      { id: 'm_png', src: '/images/e-queste/M.png', description: 'M', isIntruder: false },
      { id: 'm1', src: '/images/e-queste/M(1).jpg', description: 'M', isIntruder: false },
      { id: 'm2', src: '/images/e-queste/M(2).jpg', description: 'M', isIntruder: false },
      { id: 'n', src: '/images/e-queste/N.jpg', description: 'N', isIntruder: false },
      { id: 's', src: '/images/e-queste/S.jpg', description: 'S', isIntruder: false },
      { id: 'sec', src: '/images/e-queste/S&C.jpg', description: 'S&C', isIntruder: false },
      { id: 'intruso_c', src: '/images/e-queste/Intruso C.jpg', description: 'C', isIntruder: true },
      { id: 'intruso_m', src: '/images/e-queste/Intruso M.jpg', description: 'M', isIntruder: true },
      { id: 'intruso_u', src: '/images/e-queste/Intruso U.jpg', description: 'U', isIntruder: true }
    ],
    intruderSequence: ['intruso_c', 'intruso_m', 'intruso_u'],
    revealedLetters: 'SA'
  }
];

export const FINAL_MESSAGE = 'SOTTOLASPOSA';